<script>
import { toastState, showNextToast } from '@/plugins/toast'

// Пауза между уведомлениями из очереди, чтобы успела отыграть анимация скрытия
const NEXT_DELAY = 200

export default {
	name: 'AppToast',
	data() {
		return {
			state: toastState,
		}
	},
	computed: {
		visible: {
			get() {
				return this.state.visible
			},
			set(value) {
				this.state.visible = value
			},
		},
	},
	watch: {
		'state.visible'(visible) {
			if (!visible) setTimeout(showNextToast, NEXT_DELAY)
		},
	},
	methods: {
		close() {
			this.visible = false
		},
	},
}
</script>

<template>
	<v-snackbar
		v-model="visible"
		class="app-toast"
		:color="state.type"
		:timeout="state.timeout"
		top
		right
		multi-line
	>
		<span :role="state.type === 'error' ? 'alert' : 'status'">{{ state.text }}</span>

		<template #action="{ attrs }">
			<v-btn text icon v-bind="attrs" :aria-label="$t('toast.close')" @click="close">✕</v-btn>
		</template>
	</v-snackbar>
</template>

<style>
/* Поверх модальных окон vue-js-modal, включая ReportManageErrorModal (z-index 10001) */
.v-snack.app-toast {
	z-index: 10010;
}

.app-toast .v-snack__content {
	white-space: pre-line;
	word-break: break-word;
}
</style>
